import { Skeleton } from './Skeleton';
import { SkeletonRegion } from './SkeletonRegion';

/** `AuditTimeline` before its entries load: actor and timestamp, then the action line, per entry. */
export function TimelineSkeleton({ label, entries = 4 }: { label: string; entries?: number }) {
  return (
    <SkeletonRegion label={label} className="flex flex-col gap-4">
      {Array.from({ length: entries }, (_, entry) => (
        <div key={entry} className="flex flex-col gap-2 border-b border-line pb-4 last:border-0 last:pb-0">
          <div className="flex items-center justify-between gap-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-24" />
          </div>
          <Skeleton className="h-3 w-48 max-w-full" />
        </div>
      ))}
    </SkeletonRegion>
  );
}
